import { render, staticRenderFns } from "./EditPlatformStockCompareTemplateComponent.vue?vue&type=template&id=4d8e9d59&"
import script from "./EditPlatformStockCompareTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./EditPlatformStockCompareTemplateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports